module.exports = __webpack_public_path__ + "static/media/7.cc32d9ae.jpg";